﻿import { HTMLAttributes } from 'react';

interface MarkerTextProps extends HTMLAttributes<HTMLElement> {
    children?: string;
    highlight?: string;
}

export default function MarkerText({ children, highlight, ...props }: MarkerTextProps) {
    if (!highlight || !children) {
        return <span {...props}>{children}</span>;
    }

    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = children.split(new RegExp(`(${escapedHighlight})`, 'gi'));

    return (
        <span>
            {parts.map((part, index) =>
                part.toLowerCase() === highlight.toLowerCase() ? (
                    <mark key={index} {...props} style={{ color: 'black' }}>
                        {part}
                    </mark>
                ) : (
                    <span key={index} {...props}>
                        {part}
                    </span>
                )
            )}
        </span>
    );
}
